import {
  userEntered,
  userPlacedBet,
  userCanceledBet,
  userExited,
  userCashouted,
} from "./roundUserUpdate"

export const roundUpdateHelper = (setUsers, newUser, setCashoutedUser, prec) => {

  switch (newUser.state) {
    case 1:
      setUsers((users) => userEntered(users, newUser))
      break
    case 2:
      setUsers((users) => userPlacedBet(users, newUser))
      break
    case 3:
      setUsers((users) => userCanceledBet(users, newUser))
      break
    case 4:
      setUsers((users) => userExited(users, newUser))
      break
    case 5:
      setCashoutedUser(newUser.player_id)
      setUsers((users) => userCashouted(users, newUser, prec))
      break
    default:
      break
  }
}

